import { create } from 'zustand';
import { ColourProfile } from '../api/colours';
import { getColourProfiles, deleteColourProfile } from '../api/colours';

interface ColourState {
  profiles: ColourProfile[];
  isLoading: boolean;
  error: string | null;

  // Actions
  fetchProfiles: () => Promise<void>;
  deleteProfile: (profileId: number) => Promise<void>;
  clearError: () => void;
}

const useColourStore = create<ColourState>((set, get) => ({
  profiles: [],
  isLoading: false,
  error: null,

  fetchProfiles: async () => {
    try {
      set({ isLoading: true, error: null });
      const profiles = await getColourProfiles();
      set({ profiles, isLoading: false });
    } catch (error) {
      console.error('Error fetching profiles:', error);
      set({
        error: 'Failed to load color profiles. Please try again later.',
        isLoading: false,
      });
    }
  },

  deleteProfile: async (profileId: number) => {
    try {
      set({ isLoading: true, error: null });
      await deleteColourProfile(profileId);

      // Remove profile from state
      const updatedProfiles = get().profiles.filter(
        (profile) => profile.id !== profileId
      );

      set({ profiles: updatedProfiles, isLoading: false });
    } catch (error) {
      console.error('Error deleting profile:', error);
      set({
        error: 'Failed to delete profile. Please try again later.',
        isLoading: false,
      });
    }
  },

  clearError: () => set({ error: null }),
}));

export default useColourStore;
